export default __webpack_public_path__ + "static/media/Header-4.9cc097bd.jpg";